import { parseJsonWithoutDuplicateKeys } from "./utilities/jsonKeys";

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

async function historyParser(data, boundary, username) {
  console.log("username in history parse function:", username);
  console.log("boundary history parse function:" + boundary);
  console.log("data history parse function:" + data);

  function extractBoundary(text) {
    const lines = text.split(/\r?\n/);
    for (let line of lines) {
      if (line.startsWith("--")) {
        const boundary = line.slice(2).trim();
        if (boundary) return boundary;
      }
    }
    return null;
  }

  let raw;
  if (typeof data === 'string') {
    console.log("Data is a string");
    raw = data;
  } else if (data instanceof Blob) {
    console.log("Data is a Blob");
    raw = await data.text();
  } else if (data instanceof ArrayBuffer) {
    console.log("Data is an ArrayBuffer");
    raw = new TextDecoder().decode(data);
  } else {
    raw = String(data);
  }

  console.log("Raw data length:", raw.length);
  // console.log("Raw data first 100 chars:", raw.substring(0, 100));

  const msrpIndex = raw.indexOf('MSRP');
  if (msrpIndex !== -1) {
    raw = raw.slice(msrpIndex);
    console.log("Found MSRP at index:", msrpIndex);
  } else {
    console.log("MSRP marker not found");
  }

  console.log("Using boundary:", boundary);

  const parts = raw
    .split("--" + boundary)
    .map(p => p.trim())
    .filter(p => p && !p.startsWith('MSRP') && !p.startsWith('--'));

  console.log("Found parts:", parts.length);
  
  // Logları çok şişirmemesi için sadece başlıkları loglayabiliriz, isteğe bağlı kapatıldı.
  // parts.forEach((p, i) => {
  //   console.log(`Part ${i} (${p.length} chars): ${p.substring(0, 30)}...`);
  // });

  const messages = [];
  /** Will be attached to messages.pageInfo (does NOT break array return type) */
  let pageInfo = null;

  function _requestObtainReplyMessageParms(jmsg) {
    console.log("historyParser :: obtaining reply message request params");
    const parms = jmsg.parameters;
    if (!parms) {
      console.error('Missing "parameters" in reply message request');
      return {};
    }
    return {
      repliedMessageId: parms["message-id"],
      fromName: parms["from-name"],
      toName: parms["to-name"],
    };
  }

  function parseRepliedMessage(part) {
    // console.log("Parsing replied message", part);

    const msgIdMatch = part.match(/Msg-Id:\s*(\S+)/);
    const messageId = msgIdMatch ? msgIdMatch[1] : null;

    if (!messageId) {
      console.log("No message ID found for replied message");
      return null;
    }

    let replyMetadata = null;
    let replyText = null;

    const innerBoundary = extractBoundary(part);
    if (innerBoundary) {
      // console.log("Using inner boundary:", innerBoundary);

      const innerParts = part
        .split("--" + innerBoundary)
        .map(p => p.trim())
        .filter(p => p && !p.endsWith('--'));

      // console.log("Found inner parts:", innerParts.length);

      innerParts.forEach((innerPart, index) => {
        // console.log(`Processing inner part ${index}:`, innerPart.substring(0, 50));

        if (/Content-Type:\s*application\/rechat\.cntl\+json/.test(innerPart)) {
          const jsonMatch = innerPart.match(/\{.*\}/s);
          if (jsonMatch) {
            try {
              replyMetadata = parseJsonWithoutDuplicateKeys(jsonMatch[0]);
              // console.log("Parsed reply metadata:", replyMetadata);
            } catch (e) {
              console.error("Failed to parse reply metadata JSON:", e);
            }
          }
        }

        if (/Content-Type:\s*text\/plain/.test(innerPart)) {
          const sections = innerPart.split(/\r?\n\r?\n/);
          if (sections.length > 1) {
            replyText = sections.slice(1).join('\n').trim();
            // console.log("Found reply text:", replyText);
          }
        }
      });
    } else {
      console.log("No inner boundary found, using default parsing");
      const sections = part.split(/\r?\n\r?\n/);
      if (sections.length > 1) {
        replyText = sections.slice(1).join('\n').trim();
        // console.log("Found reply text (fallback):", replyText);
      }
    }

    let replyParams = {};
    // console.log("replyMetadata in parseRepliedMessage:", replyMetadata);
    if (replyMetadata) {
      replyParams = _requestObtainReplyMessageParms(replyMetadata);
    }

    return {
      messageId,
      replyText,
      replyMetadata,
      replyParams
    };
  }

  parts.forEach((part, index) => {
    try {
      // console.log(`Processing part ${index}:`);
      let isRepliedMessage = false;
      if (/Content-Type:\s*application\/rechat\.cntl\+json/.test(part) && part.includes('reply-to')) {
        isRepliedMessage = true;
      }

      // ====================================================
      // DURUM 1: REPLIED MESSAGE (YANITLANAN MESAJ)
      // ====================================================
      if (isRepliedMessage) {
        console.log("Detected replied message");

        const idMatch = part.match(/Msg-Id:\s*(\S+)/);
        const messageId = idMatch ? idMatch[1] : null;

        const senderMatch = part.match(/From-Name:\s*(.+?)(?:\r?\n|$)/);
        const sender = senderMatch ? senderMatch[1].trim() : null;

        const receiverMatch = part.match(/To-Name:\s*(.+?)(?:\r?\n|$)/);
        const receiver = receiverMatch ? receiverMatch[1].trim() : "";

        const roleMatch = part.match(/User-Role:\s*(\S+)/);
        const role = roleMatch ? roleMatch[1].toLowerCase() : null;

        // --- DÜZELTME: arrivalTime parse ---
        const arrivalMatch = part.match(/Arrival-Time:\s*(\d+)/);
        const arrivalTime = arrivalMatch ? parseInt(arrivalMatch[1], 10) : null;

        const sentMatch = part.match(/Sent-Time:\s*(\d+)/);
        const sentTime = sentMatch ? parseInt(sentMatch[1], 10) : null;

        const editMatch = part.match(/Edit-Time:\s*(\d+)/);
        const editTime = editMatch ? parseInt(editMatch[1], 10) : null;

        const deliveredMatch = part.match(/Delivered-Time:\s*(\d+)/);
        const deliveredTime = deliveredMatch ? parseInt(deliveredMatch[1], 10) : null;

        const deleteTimeMatch = part.match(/Delete-Time:\s*(\d+)/);
        const deletedTime = deleteTimeMatch ? parseInt(deleteTimeMatch[1], 10) : null;

        console.log("Times:", arrivalTime, sentTime, editTime, deliveredTime, deletedTime);
        const seenTimes = [];
        const readTimeRegex = /Read-Time for:\s*(.+?):\s*(\d+)/g;
        let seenMatch;

        while ((seenMatch = readTimeRegex.exec(part)) !== null) {
          const seenUser = seenMatch[1].trim();
          const seenTimestamp = parseInt(seenMatch[2], 10);
          if (seenUser && !isNaN(seenTimestamp)) {
            seenTimes.push({
              name: seenUser,
              time: new Date(seenTimestamp * 1000)
            });
          }
        }

        const repliedData = parseRepliedMessage(part);

        if (repliedData && repliedData.replyText && messageId && sender) {
          const isOwner = sender === username;
          
          // --- DÜZELTME: timestamp oluşturulurken arrivalTime kullanıldı ---
          const timestamp = new Date((arrivalTime || sentTime || 0) * 1000);
          const validTimestamp = isNaN(timestamp.getTime()) ? new Date() : timestamp;

          let replyText = repliedData.replyText;
          if (deletedTime != null) {
            replyText = "This message has been deleted";
          }

          const message = {
            text: replyText,
            messageId: messageId,
            isOwner: isOwner,
            sender: repliedData.replyParams.fromName || sender,
            receiver: repliedData.replyParams.toName || receiver,
            timestamp: validTimestamp || null,
            role: role,
            sentTime: sentTime || null,
            deliveredTime: deliveredTime || null,
            seenTimes: seenTimes,
            editTime: editTime || null,
            deletedTime: deletedTime || null,
            arrivalTime: arrivalTime || null, // Düzgün parse edildi
            repliedMessageId: repliedData.replyParams.repliedMessageId,
          };

          messages.push(message);
          console.log("Added replied message:", messageId);
        } else {
          console.log("Skipped replied message: Missing required fields");
        }

        return;
      }

      // JSON control messages (includes file-transfer job AND history meta)
      if (/Content-Type:\s*application\/rechat\.cntl\+json/.test(part)) {
        // console.log("Found JSON message, checking details...");

        const jsonMatch = part.match(/\{.*\}/s);
        if (jsonMatch) {
          try {
            const jsonData = parseJsonWithoutDuplicateKeys(jsonMatch[0]);
            // console.log("Parsed JSON data:", jsonData);

            // ---- NEW: capture history pagination meta if present ----
            if (
              jsonData &&
              (jsonData.type === "response" || jsonData.type === "event") &&
              String(jsonData.detail || "").toLowerCase() === "message-history" &&
              jsonData.parameters && typeof jsonData.parameters === "object"
            ) {
              const p = jsonData.parameters || {};
              pageInfo = {
                toName: p["to-name"] ?? null,
                fromName: p["from-name"] ?? null,
                limit: typeof p["limit"] === "number" ? p["limit"] : null,
                pageNumber: typeof p["page-number"] === "number" ? p["page-number"] : null,
                totalPageNumber: typeof p["total-page-number"] === "number" ? p["total-page-number"] : null,
                raw: jsonData
              };
              console.log("Captured pageInfo:", pageInfo);
            }

            // ====================================================
            // DURUM 2: FILE TRANSFER (DOSYA TRANSFERİ)
            // ====================================================
            if (jsonData.job === "file-transfer" && jsonData.parameters) {
              console.log("Processing file transfer message");

              const idMatch = part.match(/Msg-Id:\s*(\S+)/);
              const messageId = idMatch ? idMatch[1] : null;

              const senderMatch = part.match(/From-Name:\s*(.+?)(?:\r?\n|$)/);
              const sender = senderMatch ? senderMatch[1].trim() : null;

              const receiverMatch = part.match(/To-Name:\s*(.+?)(?:\r?\n|$)/);
              const receiver = receiverMatch ? receiverMatch[1].trim() : "";

              const roleMatch = part.match(/User-Role:\s*(\S+)/);
              const role = roleMatch ? roleMatch[1].toLowerCase() : null;

              // --- DÜZELTME: arrivalTime parse (arrivalSec yerine arrivalTime kullanıldı) ---
              const arrivalMatch = part.match(/Arrival-Time:\s*(\d+)/);
              const arrivalTime = arrivalMatch ? parseInt(arrivalMatch[1], 10) : null;

              const sentMatch = part.match(/Sent-Time:\s*(\d+)/);
              const sentTime = sentMatch ? parseInt(sentMatch[1], 10) : null;

              const editMatch = part.match(/Edit-Time:\s*(\d+)/);
              const editTime = editMatch ? parseInt(editMatch[1], 10) : null;

              const deliveredMatch = part.match(/Delivered-Time:\s*(\d+)/);
              const deliveredTime = deliveredMatch ? parseInt(deliveredMatch[1], 10) : null;

              const deleteTimeMatch = part.match(/Delete-Time:\s*(\d+)/);
              const deletedTime = deleteTimeMatch ? parseInt(deleteTimeMatch[1], 10) : null;

              const replyToMatch = part.match(/Replied-To-Message:\s*(\S+)/);
              const repliedMessageId = replyToMatch ? replyToMatch[1] : null;

              const seenTimes = [];
              const readTimeRegex = /Read-Time for:\s*(.+?):\s*(\d+)/g;
              let seenMatch;
        console.log("Times:", arrivalTime, sentTime, editTime, deliveredTime, deletedTime);

              while ((seenMatch = readTimeRegex.exec(part)) !== null) {
                const seenUser = seenMatch[1].trim();
                const seenTimestamp = parseInt(seenMatch[2], 10);
                if (seenUser && !isNaN(seenTimestamp)) {
                  seenTimes.push({
                    name: seenUser,
                    time: new Date(seenTimestamp * 1000)
                  });
                }
              }

              if (messageId && sender) {
                const isOwner = sender === username;
                
                // --- DÜZELTME: timestamp oluşturulurken arrivalTime kullanıldı ---
                const timestamp = new Date((arrivalTime || sentTime || 0) * 1000);
                const validTimestamp = isNaN(timestamp.getTime()) ? new Date() : timestamp;

                const params = jsonData.parameters;
                const fileName = params["file-name"] || "Unknown file";
                const fileSize = params["file-size"] ? formatFileSize(params["file-size"]) : "";
                let displayText = `📎 ${fileName}${fileSize ? ` (${fileSize})` : ""}`;

                if (deletedTime != null) {
                  displayText = "This message has been deleted";
                }

                const message = {
                  text: displayText,
                  messageId: messageId,
                  isOwner: isOwner,
                  sender: sender,
                  receiver: receiver,
                  timestamp: validTimestamp || null,
                  role: role,
                  sentTime: sentTime || null,
                  deliveredTime: deliveredTime || null,
                  seenTimes: seenTimes,
                  editTime: editTime || null,
                  deletedTime: deletedTime || null,
                  arrivalTime: arrivalTime || null, // Eklendi
                  repliedMessageId: repliedMessageId || null,
                  messageType: "file-transfer",
                  fileData: {
                    fileName: params["file-name"],
                    fileType: params["file-type"],
                    fileSize: params["file-size"],
                    fileHash: params["file-hash"],
                    fileLocation: params["file-location"],
                    fileTitle: params["file-title"],
                    transferId: params["file-transfer-id"],
                    creationDate: params["file-creation-date"],
                    modificationDate: params["file-modification-date"],
                    direction: params["direction"]
                  }
                };

                messages.push(message);
                console.log("Added file transfer message:", messageId);
              } else {
                console.log("Skipped file transfer: Missing required fields");
              }

              return; // Exit early for file transfer messages
            }
          } catch (e) {
            console.error("Failed to parse JSON in rechat.cntl+json message:", e);
          }
        }
      }

      // Regular text & application/json plain payloads
      if (!/Content-Type:\s*text\/plain/.test(part) && !/Content-Type:\s*application\/json/.test(part)) {
        return;
      }

      // ====================================================
      // DURUM 3: NORMAL TEXT MESSAGE (STANDART MESAJ)
      // ====================================================
      const idMatch = part.match(/Msg-Id:\s*(\S+)/);
      const messageId = idMatch ? idMatch[1] : null;

      const senderMatch = part.match(/From-Name:\s*(.+?)(?:\r?\n|$)/);
      const sender = senderMatch ? senderMatch[1].trim() : null;

      const receiverMatch = part.match(/To-Name:\s*(.+?)(?:\r?\n|$)/);
      const receiver = receiverMatch ? receiverMatch[1].trim() : "";

      const replyToMatch = part.match(/Replied-To-Message:\s*(\S+)/);
      const repliedMessageId = replyToMatch ? replyToMatch[1] : null;

      const roleMatch = part.match(/User-Role:\s*(\S+)/);
      const role = roleMatch ? roleMatch[1].toLowerCase() : null;

      const companyDomainMatch = part.match(/Company-Domain:\s*(\S+)/);
      const companyDomain = companyDomainMatch ? companyDomainMatch[1] : null;

      // --- DÜZELTME: arrivalTime parse (arrivalSec yerine arrivalTime kullanıldı) ---
      const arrivalMatch = part.match(/Arrival-Time:\s*(\d+)/);
      const arrivalTime = arrivalMatch ? parseInt(arrivalMatch[1], 10) : null;

      const editMatch = part.match(/Edit-Time:\s*(\d+)/);
      const editTime = editMatch ? parseInt(editMatch[1], 10) : null;

      const sentMatch = part.match(/Sent-Time:\s*(\d+)/);
      const sentTime = sentMatch ? parseInt(sentMatch[1], 10) : null;

      const seenTimes = [];
      const readTimeRegex = /Read-Time for:\s*(.+?):\s*(\d+)/g;
      let seenMatch;

      while ((seenMatch = readTimeRegex.exec(part)) !== null) {
        const seenUser = seenMatch[1].trim();
        const seenTimestamp = parseInt(seenMatch[2], 10);
        if (seenUser && !isNaN(seenTimestamp)) {
          seenTimes.push({
            name: seenUser,
            time: new Date(seenTimestamp * 1000)
          });
        }
      }

      // console.log(`Found ${seenTimes.length} seen times for message ${messageId}`);

      const deliveredMatch = part.match(/Delivered-Time:\s*(\d+)/);
      const deliveredTime = deliveredMatch ? parseInt(deliveredMatch[1], 10) : null;

      const deleteTimeMatch = part.match(/Delete-Time:\s*(\d+)/);
      const deletedTime = deleteTimeMatch ? parseInt(deleteTimeMatch[1], 10) : null;

      const sections = part.split(/\r?\n\r?\n/);
      let text = sections.length > 1 ? sections.slice(1).join('\n').trim() : '';

      if (deletedTime != null) {
        text = "This message has been deleted";
      }

      if (messageId && sender && text) {
        const isOwner = sender === username;
        
        const timestamp = new Date((arrivalTime || sentTime || 0) * 1000);
        const validTimestamp = isNaN(timestamp.getTime()) ? new Date() : timestamp;

        messages.push({
          text: text,
          messageId: messageId,
          isOwner: isOwner,
          sender: sender,
          receiver: receiver,
          timestamp: validTimestamp || null,
          role: role,
          sentTime: sentTime || null,
          deliveredTime: deliveredTime || null,
          seenTimes: seenTimes,
          editTime: editTime || null,
          deletedTime: deletedTime || null,
          arrivalTime: arrivalTime || null, // Eklendi
          repliedMessageId: repliedMessageId || null,
          messageType: "text",
          companyDomain: companyDomain
        });
      } else {
        console.log(`- Skipped: Missing required fields`);
      }
    } catch (error) {
      console.error(`Error parsing part ${index}:`, error);
    }
  });

  // Attach pageInfo without changing the return type (array)
  if (pageInfo) {
    Object.defineProperty(messages, 'pageInfo', {
      value: pageInfo,
      enumerable: false,
      writable: false
    });
  }

  console.log("Final messages array length:", messages.length);
  if (pageInfo) console.log("Final messages.pageInfo:", pageInfo);
  return messages;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { historyParser };
}

export { historyParser };